import APIControl from './APIControl';
import {translate} from '../Tools/LanguageTools';
import {Strtob64, b64toStr2} from '../Tools/Base64Decode';

function EncodePortalString(tstr) {
  let res = Strtob64(tstr.toString());
  res = res.split('').reverse().join('');
  return res;
}
export function DecodePortalString(tstr) {
  let res = tstr.toString().split('').reverse().join('');
  res = b64toStr2(res);
  return res;
}

function getTableData(
  type,
  filters = {},
  fields = undefined,
  search = undefined,
  mainclick = false,
  page = undefined,
  perpage = undefined,
  sortkey = undefined,
  order = undefined,
  browse_search = undefined,
  sd = undefined,
  ed = undefined,
  bfilter = undefined
) {
  let url = '/WebHRAction.hal?action=getdata&type=' + EncodePortalString(type);
  let click = '';
  if (mainclick) {
    click = '1';
  }
  return APIControl({
    url: url,
    method: 'POST',
    data: {
      filters,
      fields,
      search,
      click,
      page,
      perpage,
      sortkey,
      order,
      browse_search,
      sd,
      ed,
      bfilter,
    },
  });
}

function postRecord(type, content) {
  return APIControl({
    url: '/WebHRAction.hal?action=postdata&type=' + EncodePortalString(type),
    method: 'POST',
    data: {
      content,
    },
  });
}

function getReport(options) {
  let tstr = Strtob64(JSON.stringify(options));
  return APIControl({
    url: '/WebHRAction.hal?action=getreport',
    method: 'POST',
    data: tstr,
  });
}

function getNewRecord(type, content) {
  return APIControl({
    url: '/WebHRAction.hal?action=postdata&type=' + EncodePortalString(type),
    method: 'POST',
    data: content,
    startText: translate('CreatingRecord'),
    endText: ' ',
  });
}
function doAction(type, content, extras) {
  return APIControl({
    url: '/WebHRAction.hal?action=action&type=' + type,
    method: 'POST',
    data: {
      content,
      extras,
    },
  });
}
function updateRecordData(type, content) {
  return APIControl({
    url: '/WebHRAction.hal?action=postdata&type=' + EncodePortalString(type),
    method: 'POST',
    data: content,
    startText: translate('UpdatingRecord'),
  });
}
function deleteRecordRow(type, id) {
  return APIControl({
    url:
      '/WebHRAction.hal?action=deleterow&type=' +
      EncodePortalString(type) +
      '&id=' +
      id,
    method: 'POST',
    startText: translate('UpdatingRecord'),
  });
}

function insertRecordRow(type, id) {
  return APIControl({
    url:
      '/WebHRAction.hal?action=insertrow&type=' +
      EncodePortalString(type) +
      '&id=' +
      id,
    method: 'POST',
  });
}

function deleteRecord(type, id) {
  return APIControl({
    url:
      '/WebHRAction.hal?action=deleterecord&type=' +
      EncodePortalString(type) +
      '&id=' +
      id,
    method: 'GET',
    startText: translate('DeletingRecord'),
    endText: translate('SuccessfullyDeletedRecord'),
  });
}
function downloadDocument(type, content) {
  return APIControl({
    url: '/WebHRAction.hal?action=downloaddoc&type=' + EncodePortalString(type),
    method: 'POST',
    data: content,
    startText: translate('RequestingFile'),
  });
}

function getEmployeeData() {
  return APIControl({
    url: '/WebHRAction.hal?action=getuserdata',
    method: 'GET',
  });
}

function logout() {
  return APIControl({
    url: '/WebUpdatingAction.hal?action=logout',
    method: 'GET',
  });
}

function switchCompany(newcomp) {
  return APIControl({
    url: '/WebHRAction.hal?action=switchcomp&compuuid=' + newcomp,
    method: 'GET',
  });
}

function TestLogin(username, password) {
  return APIControl({
    url: '/dologin',
    method: 'POST',
    data:
      'login=' +
      username +
      '&passwd=' +
      password +
      '&company=1&failed=' +
      encodeURIComponent('/WebUpdatingAction.hal?action=afterlogin&failed=1') +
      '&custpage=' +
      encodeURIComponent('/WebUpdatingAction.hal?action=afterlogin&cust=1'),
  });
}

function testConnection() {
  return APIControl({
    url: '/WebHRAction.hal?action=dummy',
    method: 'GET',
  });
}
function ResetLogin() {
  return APIControl({
    url: '/WebHRAction.hal?action=resetlogin',
    method: 'GET',
  });
}
function ResetPassword(email) {
  return APIControl({
    url: '/WebUpdatingAction.hal?action=createnewpasssess&email=' + email,
    method: 'GET',
  });
}
function getWindowDefs(language) {
  return APIControl({
    url: '/WebHRAction.hal?action=getwindowdefs&langcode=' + language,
    method: 'GET',
  });
}

const Requests = {
  getTableData,
  postRecord,
  logout,
  getEmployeeData,
  getNewRecord,
  updateRecordData,
  deleteRecord,
  downloadDocument,
  switchCompany,
  deleteRecordRow,
  testConnection,
  doAction,
  TestLogin,
  insertRecordRow,
  ResetPassword,
  getReport,
  ResetLogin,
  getWindowDefs,
};

export default Requests;
